import React from "react";

const Help = () => {
  return <h2 className="text-cyan-950 align-bottom">How can we help you ?</h2>;
};

export default Help;
